






















































































































































import { Component, Vue } from "vue-property-decorator";
import TimeSeriesChart from "@/components/TimeSeriesChart.vue";
import Sparkline from "vue-sparklines";
import { ChartOptions } from "chart.js";
import Chart from "chart.js";
import "chartjs-plugin-colorschemes";

// import { Store } from "vuex";
import { readUserProfile, readShares } from "@/store/main/getters";
import { dispatchGetShares } from "@/store/main/actions";

/**
 * Data (Label with values)
 */
export interface Data {
  label: string;
  data: Value[];
}
/**
 * Value
 */
export interface Value {
  x: Date;
  y: number;
}

@Component({
  components: {
    TimeSeriesChart,
    Sparkline
  }
})
export default class Shares extends Vue {
  private allData: Data[] = [];
  private chartData: Chart.ChartData = {};
  private chartStyles = {
    height: "100%",
    width: "100%",
    margin: "auto"
  };

  private share_summations = {};
  private share_miners = {};

  private time_diff = 0;

  private sum_valid = 0;
  private sum_stale = 0;
  private sum_invalid = 0;

  public get_sums = {
    sum_valid: 0,
    sum_stale: 0,
    sum_invalid: 0
  };

  get calculate_hashrate() {
    // return `${this.get_sums.sum_valid}/${this.time_diff}`;
    return (
      ((this.get_sums.sum_valid / this.time_diff) * 4.295 * 1000).toFixed(2) +
      "MH"
    );
  }

  get shares() {
    return readShares(this.$store);
    // return { value: [423, 446, 675, 510, 590, 610, 760] };
  }
  // get getSums() {
  //   let sum_valid = 0;
  //   let sum_stale = 0;
  //   let sum_invalid = 0;
  //   readShares(this.$store).forEach(share => {
  //     sum_valid += share.valid_count;
  //     sum_stale += share.stale_count;
  //     sum_invalid += share.invalid_count;
  //   });
  //   const counts = {
  //     sum_valid: sum_valid,
  //     sum_stale: sum_stale,
  //     sum_invalid: sum_invalid
  //   };
  //   return counts;
  // }
  get counts() {
    const valid_counts: number[] = [];
    const stale_counts: number[] = [];
    const invalid_counts: number[] = [];
    const times: Date[] = [];
    this.sum_valid = 0;
    this.sum_stale = 0;
    this.sum_invalid = 0;

    readShares(this.$store).forEach(share => {
      valid_counts.push(share.valid_count);
      stale_counts.push(share.stale_count);
      invalid_counts.push(share.invalid_count);
      times.push(new Date(share.created + "Z"));
      this.sum_valid += share.valid_count;
      this.sum_stale += share.stale_count;
      this.sum_invalid += share.invalid_count;
    });
    const counts = {
      valid_counts: valid_counts,
      stale_counts: stale_counts,
      invalid_counts: invalid_counts,
      times: times
    };
    return counts;
  }
  get lineOptions() {
    return {
      elements: {
        line: {
          fill: false
        }
      }
    };
  }
  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      if (userProfile.full_name) {
        return userProfile.full_name;
      } else {
        return userProfile.email;
      }
    }
    return null;
  }
  get userProfile() {
    return readUserProfile(this.$store);
  }
  public async mounted() {
    await dispatchGetShares(this.$store);

    const shares = readShares(this.$store);

    // summations
    const time_start = new Date(shares[shares.length - 1].created);
    const time_end = new Date(shares[0].created);

    console.log(time_start.getTime(), time_end.getTime());

    this.time_diff = (time_end.getTime() - time_start.getTime()) / 10 ** 3;

    console.log(this.time_diff);

    let sum_valid = 0;
    let sum_stale = 0;
    let sum_invalid = 0;
    shares.forEach(share => {
      sum_valid += share.valid_count;
      sum_stale += share.stale_count;
      sum_invalid += share.invalid_count;
    });
    this.get_sums.sum_valid = sum_valid;
    this.get_sums.sum_stale = sum_stale;
    this.get_sums.sum_invalid = sum_invalid;

    // Initialize chart data
    this.allData.push({ label: "نامعتبر", data: [] });
    this.allData.push({ label: "دیر هنگام", data: [] });
    this.allData.push({ label: "معتبر", data: [] });

    for (const share of shares) {
      if (share.created in this.share_summations) {
        this.share_summations[share.created] = [
          this.share_summations[share.created][0] + share.valid_count,
          this.share_summations[share.created][1] + share.stale_count,
          this.share_summations[share.created][2] + share.invalid_count
        ];
      } else {
        this.share_summations[share.created] = [
          share.valid_count,
          share.stale_count,
          share.invalid_count
        ];
      }
    }

    for (const key in this.share_summations) {
      const val = this.share_summations[key];
      this.allData[2].data.push({
        x: new Date(key + "Z"),
        y: val[0]
      });
      this.allData[1].data.push({
        x: new Date(key + "Z"),
        y: val[1]
      });
      this.allData[0].data.push({
        x: new Date(key + "Z"),
        y: val[2]
      });
    }

    for (let i = 0; i < 3; i++) {
      this.allData[i].data = this.allData[i].data.sort((s1, s2) => {
        if (s1.x > s2.x) {
          return 1;
        }

        if (s1.x < s2.x) {
          return -1;
        }

        return 0;
      });
    }

    const dataset = (labelData: Data) => ({
      label: labelData.label,
      data: labelData.data,
      radius: 5
    });
    this.chartData = {
      datasets: this.allData.map(label => dataset(label))
    };

    // group by miners
    for (const share of shares) {
      if (share.miner_id in this.share_miners) {
        this.share_miners[share.miner_id].push(share);
      } else {
        this.share_miners[share.miner_id] = [share];
      }
    }
  }
}
